export const SubstituteIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.98082 10.5422C4.85935 10.4209 4.66292 10.4209 4.54145 10.5422C4.41997 10.6635 4.41997 10.8597 4.54145 10.981L4.89294 11.3319H3.46627C2.53841 11.3319 1.78631 10.5784 1.78631 9.65444V8.61438C1.78631 8.44405 1.64674 8.30469 1.47616 8.30469C1.30558 8.30469 1.16602 8.44405 1.16602 8.61438V9.65444C1.16602 10.9216 2.19725 11.9513 3.46627 11.9513H4.89294L4.54145 12.3023C4.41997 12.4236 4.41997 12.6198 4.54145 12.741C4.60089 12.8004 4.68101 12.8314 4.76113 12.8314C4.84125 12.8314 4.91879 12.8004 4.98082 12.741L5.86215 11.861C5.98363 11.7397 5.98363 11.5436 5.86215 11.4223L4.98082 10.5422Z"
        fill="#222530"
      />
      <path
        d="M6.59376 1.16406H1.4996C1.32902 1.16406 1.18945 1.30342 1.18945 1.47376V6.56047C1.18945 6.7308 1.32902 6.87017 1.4996 6.87017H6.59376C6.76434 6.87017 6.90391 6.7308 6.90391 6.56047V1.47376C6.90391 1.30342 6.76692 1.16406 6.59376 1.16406ZM6.28361 6.25078H1.80975V1.78345H6.28361V6.25078Z"
        fill="#222530"
      />
      <path
        d="M10.5293 2.04475H9.10265L9.45415 1.69377C9.57563 1.57247 9.57563 1.37633 9.45415 1.25503C9.33268 1.13374 9.13625 1.13374 9.01478 1.25503L8.13603 2.13508C8.01455 2.25638 8.01455 2.45252 8.13603 2.57381L9.01736 3.45386C9.07681 3.51322 9.15693 3.54419 9.23705 3.54419C9.31717 3.54419 9.39471 3.51322 9.45674 3.45386C9.57821 3.33256 9.57821 3.13642 9.45674 3.01513L9.10524 2.66414H10.5319C11.4598 2.66414 12.2119 3.41773 12.2119 4.34165V5.3817C12.2119 5.55203 12.3514 5.6914 12.522 5.6914C12.6926 5.6914 12.8322 5.55203 12.8322 5.3817V4.34165C12.8322 3.07449 11.7983 2.04475 10.5293 2.04475Z"
        fill="#222530"
      />
      <path
        d="M12.4976 12.2109C12.4149 12.2109 12.3348 12.2445 12.278 12.3013C12.2211 12.358 12.1875 12.438 12.1875 12.5206C12.1875 12.6006 12.2211 12.6832 12.278 12.74C12.3348 12.7968 12.4149 12.8303 12.4976 12.8303C12.5804 12.8303 12.6605 12.7968 12.7173 12.74C12.7742 12.6832 12.8078 12.6032 12.8078 12.5206C12.8078 12.438 12.7742 12.358 12.7173 12.3013C12.6579 12.2445 12.5778 12.2109 12.4976 12.2109Z"
        fill="#222530"
      />
      <path
        d="M11.2242 12.2109C11.0536 12.2109 10.9141 12.3503 10.9141 12.5206C10.9141 12.691 11.0536 12.8303 11.2242 12.8303C11.3948 12.8303 11.5344 12.691 11.5344 12.5206C11.5344 12.3503 11.3948 12.2109 11.2242 12.2109Z"
        fill="#222530"
      />
      <path
        d="M8.67733 12.2109C8.50675 12.2109 8.36719 12.3503 8.36719 12.5206C8.36719 12.691 8.50675 12.8303 8.67733 12.8303C8.84792 12.8303 8.98748 12.691 8.98748 12.5206C8.98748 12.3503 8.8505 12.2109 8.67733 12.2109Z"
        fill="#222530"
      />
      <path
        d="M9.95077 12.2109C9.78019 12.2109 9.64062 12.3503 9.64062 12.5206C9.64062 12.691 9.78019 12.8303 9.95077 12.8303C10.1214 12.8303 10.2609 12.691 10.2609 12.5206C10.2609 12.3503 10.1214 12.2109 9.95077 12.2109Z"
        fill="#222530"
      />
      <path
        d="M7.40585 12.2109C7.32314 12.2109 7.24302 12.2445 7.18616 12.3013C7.1293 12.358 7.0957 12.438 7.0957 12.5206C7.0957 12.6006 7.1293 12.6832 7.18616 12.74C7.24302 12.7968 7.32314 12.8303 7.40585 12.8303C7.48597 12.8303 7.56868 12.7968 7.62554 12.74C7.6824 12.6832 7.716 12.6032 7.716 12.5206C7.716 12.438 7.6824 12.358 7.62554 12.3013C7.56868 12.2445 7.48595 12.2109 7.40585 12.2109Z"
        fill="#222530"
      />
      <path
        d="M7.40585 10.9375C7.23527 10.9375 7.0957 11.0769 7.0957 11.2472C7.0957 11.4175 7.23527 11.5569 7.40585 11.5569C7.57643 11.5569 7.716 11.4175 7.716 11.2472C7.716 11.0769 7.5764 10.9375 7.40585 10.9375Z"
        fill="#222530"
      />
      <path
        d="M7.40585 9.66797C7.23527 9.66797 7.0957 9.80733 7.0957 9.97766C7.0957 10.148 7.23527 10.2874 7.40585 10.2874C7.57643 10.2874 7.716 10.148 7.716 9.97766C7.716 9.80733 7.5764 9.66797 7.40585 9.66797Z"
        fill="#222530"
      />
      <path
        d="M7.40585 8.39453C7.23527 8.39453 7.0957 8.53389 7.0957 8.70423C7.0957 8.87456 7.23527 9.01392 7.40585 9.01392C7.57643 9.01392 7.716 8.87456 7.716 8.70423C7.716 8.53389 7.5764 8.39453 7.40585 8.39453Z"
        fill="#222530"
      />
      <path
        d="M7.40585 7.125C7.32314 7.125 7.24302 7.15855 7.18616 7.21533C7.1293 7.2721 7.0957 7.35211 7.0957 7.43469C7.0957 7.51728 7.1293 7.59728 7.18616 7.65406C7.24302 7.71084 7.32314 7.74439 7.40585 7.74439C7.48597 7.74439 7.56868 7.71084 7.62554 7.65406C7.6824 7.59728 7.716 7.51728 7.716 7.43469C7.716 7.35469 7.6824 7.2721 7.62554 7.21533C7.56607 7.15597 7.48595 7.125 7.40585 7.125Z"
        fill="#222530"
      />
      <path
        d="M11.2242 7.125C11.0536 7.125 10.9141 7.26436 10.9141 7.43469C10.9141 7.60503 11.0536 7.74439 11.2242 7.74439C11.3948 7.74439 11.5344 7.60503 11.5344 7.43469C11.5344 7.26436 11.3948 7.125 11.2242 7.125Z"
        fill="#222530"
      />
      <path
        d="M9.95077 7.125C9.78019 7.125 9.64062 7.26436 9.64062 7.43469C9.64062 7.60503 9.78019 7.74439 9.95077 7.74439C10.1214 7.74439 10.2609 7.60503 10.2609 7.43469C10.2609 7.26436 10.1214 7.125 9.95077 7.125Z"
        fill="#222530"
      />
      <path
        d="M8.67733 7.125C8.50675 7.125 8.36719 7.26436 8.36719 7.43469C8.36719 7.60503 8.50675 7.74439 8.67733 7.74439C8.84792 7.74439 8.98748 7.60503 8.98748 7.43469C8.98748 7.26436 8.8505 7.125 8.67733 7.125Z"
        fill="#222530"
      />
      <path
        d="M12.4976 7.125C12.4149 7.125 12.3348 7.15855 12.278 7.21533C12.2211 7.2721 12.1875 7.35211 12.1875 7.43469C12.1875 7.51728 12.2211 7.59728 12.278 7.65406C12.3348 7.71084 12.4149 7.74439 12.4976 7.74439C12.5804 7.74439 12.6605 7.71084 12.7173 7.65406C12.7742 7.59728 12.8078 7.51728 12.8078 7.43469C12.8078 7.35469 12.7742 7.2721 12.7173 7.21533C12.6579 7.15855 12.5778 7.125 12.4976 7.125Z"
        fill="#222530"
      />
      <path
        d="M12.4976 8.39453C12.3271 8.39453 12.1875 8.53389 12.1875 8.70423C12.1875 8.87456 12.3271 9.01392 12.4976 9.01392C12.6682 9.01392 12.8078 8.87456 12.8078 8.70423C12.8078 8.53389 12.6682 8.39453 12.4976 8.39453Z"
        fill="#222530"
      />
      <path
        d="M12.4976 10.9375C12.3271 10.9375 12.1875 11.0769 12.1875 11.2472C12.1875 11.4175 12.3271 11.5569 12.4976 11.5569C12.6682 11.5569 12.8078 11.4175 12.8078 11.2472C12.8078 11.0769 12.6682 10.9375 12.4976 10.9375Z"
        fill="#222530"
      />
      <path
        d="M12.4976 9.66797C12.3271 9.66797 12.1875 9.80733 12.1875 9.97766C12.1875 10.148 12.3271 10.2874 12.4976 10.2874C12.6682 10.2874 12.8078 10.148 12.8078 9.97766C12.8078 9.80733 12.6682 9.66797 12.4976 9.66797Z"
        fill="#222530"
      />
    </svg>
  );
};
